/**
 * @namespace Pixel
 * @aka COMMON.Pixel
 *
 */
COMMON.Pixel = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  var Pixel = {

    /**
     * Returns true or false based on whether doNotTack is enabled. It also takes into account the
     * anomalies, such as !bugzilla 887703, which effect versions of Fx 31 and lower. It also handles
     * IE versions on Windows 7, 8 and 8.1, where the DNT implementation does not honor the spec.
     * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1217896 for more details
     * @params {string} [dnt] - An optional mock doNotTrack string to ease unit testing.
     * @params {string} [userAgent] - An optional mock userAgent string to ease unit testing.
     * @returns {boolean} true if enabled else false
     */
    dntEnabled: function (dnt, userAgent) {

      // for old version of IE we need to use the msDoNotTrack property of navigator
      // on newer versions, and newer platforms, this is doNotTrack but, on the window object
      // Safari also exposes the property on the window object.
      var dntStatus = dnt || navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack;
      var ua = userAgent || navigator.userAgent;

      // List of Windows versions known to not implement DNT according to the standard.
      var anomalousWinVersions = ['Windows NT 6.1', 'Windows NT 6.2', 'Windows NT 6.3'];

      var fxMatch = ua.match(/Firefox\/(\d+)/);
      var ieRegEx = /MSIE|Trident/i;
      var isIE = ieRegEx.test(ua);
      // Matches from Windows up to the first occurance of ; un-greedily
      // http://www.regexr.com/3c2el
      var platform = ua.match(/Windows.+?(?=;)/g);

      // With old versions of IE, DNT did not exist so we simply return false;
      if (isIE && typeof Array.prototype.indexOf !== 'function') {
        return false;
      } else if (fxMatch && parseInt(fxMatch[1], 10) < 32) {
        // Can't say for sure if it is 1 or 0, due to Fx bug 887703
        dntStatus = 'Unspecified';
      } else if (isIE && platform && anomalousWinVersions.indexOf(platform.toString()) !== -1) {
        // default is on, which does not honor the specification
        dntStatus = 'Unspecified';
      } else {
        // sets dntStatus to Disabled or Enabled based on the value returned by the browser.
        // If dntStatus is undefined, it will be set to Unspecified
        dntStatus = {'0': 'Disabled', '1': 'Enabled'}[dntStatus] || 'Unspecified';
      }

      return dntStatus === 'Enabled';
    },

    toAtiString: function toAtiString(string) {
      if ('string' !== typeof string) {
        return '';
      }

      //string = string.replace(/ /g, "_"); siehe SOS-16852
      string = string.replace(/[\xc0\xc1\xc2\xc3\xc5\xc6]/g, "A");
      string = string.replace(/[\xe0\xe1\xe2\xe3\xe5\xe6]/g, "a");
      string = string.replace(/[\xc8-\xcb]/g, "E");
      string = string.replace(/[\xe8-\xeb]/g, "e");
      string = string.replace(/[\xcc-\xcf]/g, "I");
      string = string.replace(/[\xec-\xef]/g, "i");
      string = string.replace(/[\xd2\xd3\xd4\xd5\xd8]/g, "O");
      string = string.replace(/[\xf2\xf3\xf4\xf5\xf8]/g, "o");
      string = string.replace(/[\xd9\xda\xdb]/g, "U");
      string = string.replace(/[\xf9\xfa\xfb]/g, "u");
      string = string.replace(/[\xc7]/g, "C");
      string = string.replace(/[\xe7]/g, "c");
      string = string.replace(/[\xd1]/g, "N");
      string = string.replace(/[\xf1]/g, "n");
      string = string.replace(/[^\wäöüß\.\/\-~ ]/gi, "_");
      return string;
    },

    /**
     * @param options {url, title, cb.useCanonical, cb.path, cb.sections, ati.xtpage, ati.xt_pageID, ati.xt_pageDate, ati.xt_chap}
     */
    pageview: function pageview(options) {
      if (typeof options === 'undefined') {
        options = {};
      }

      // Chartbeat
      if ('undefined' !== typeof window.pSUPERFLY) {
        var $chartbeat = $('#chartbeat');
        var cb = (options.cb || {
          useCanonical: ($chartbeat.attr('data-useCanonical') === 'false' ? !1 : !0),
          path: ($chartbeat.attr('data-path') || window.location.pathname),
          sections: ($chartbeat.attr('data-sections') || '')
        });

        window._sf_async_config.useCanonical = cb.useCanonical;
        window._sf_async_config.path = cb.path;
        window._sf_async_config.sections = cb.sections;

        try {
          window.pSUPERFLY.virtualPage({
            sections: cb.sections,
            authors: "",
            path: cb.useCanonical ? (COMMON.Utils.parseUrl((options.url || $('head link[rel="canonical"]').attr('href'))).relative) : cb.path,
            title: (options.title || document.title)
          });
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e)
        }
      }

      // Universal Analytics Web Tracking
      if ('undefined' !== typeof window.ga) {
        try {
          window.ga('send', 'pageview', {
            'page': COMMON.Utils.parseUrl((options.url || document.URL)).relative,
            'title': (options.title || document.title)
          })
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e)
        }
      }

      // AT Internet
      if ('undefined' !== typeof window.ATInternet && 'undefined' !== typeof window.ATInternet.Tracker) {
        $ati = $('#ati');
        if (!options.hasOwnProperty('ati')) {
          options.ati = {};
        }

        var customObject = {
          page_id: options.ati.pageid
        };
        if (options.ati.hasOwnProperty('chapter1')) {
          customObject.chapter3 = options.ati.hasOwnProperty('chapter3') ? options.ati.chapter3 : '';
          customObject.chapter2 = options.ati.hasOwnProperty('chapter2') ? options.ati.chapter2 : '';
          customObject.chapter1 = options.ati.hasOwnProperty('chapter1') ? options.ati.chapter1 : '';
        } else {
          customObject.chapter3 = encodeURIComponent('undefined' !== typeof $ati.data('chapter3') ? $ati.data('chapter3') : '');
          customObject.chapter2 = encodeURIComponent('undefined' !== typeof $ati.data('chapter2') ? $ati.data('chapter2') : '');
          customObject.chapter1 = encodeURIComponent('undefined' !== typeof $ati.data('chapter1') ? $ati.data('chapter1') : '');
        }

        var tag = new window.ATInternet.Tracker.Tag(window.ati_options || {});
        tag.page.set({
          name: options.ati.hasOwnProperty('name') ? options.ati.name : $ati.data('name'),
          level2: options.ati.hasOwnProperty('level2') ? options.ati.level2 : $ati.data('level2'),
          customObject: customObject
        });

        var dynamicLabel = {
          update: options.ati.hasOwnProperty('update') ? options.ati.update : $ati.data('update'),
          pageId: options.ati.hasOwnProperty('pageid') ? options.ati.pageid : $ati.data('pageid')
        };
        if (options.ati.hasOwnProperty('chapter1')) {
          dynamicLabel.chapter3 = options.ati.hasOwnProperty('chapter3') ? options.ati.chapter3 : '';
          dynamicLabel.chapter2 = options.ati.hasOwnProperty('chapter2') ? options.ati.chapter2 : '';
          dynamicLabel.chapter1 = options.ati.hasOwnProperty('chapter1') ? options.ati.chapter1 : '';
        } else {
          dynamicLabel.chapter3 = this.toAtiString('undefined' !== $ati.data('chapter3') ? $ati.data('chapter3') : '');
          dynamicLabel.chapter2 = this.toAtiString('undefined' !== $ati.data('chapter2') ? $ati.data('chapter2') : '');
          dynamicLabel.chapter1 = this.toAtiString('undefined' !== $ati.data('chapter1') ? $ati.data('chapter1') : '');
        }
        tag.dynamicLabel.set(dynamicLabel);

        var siteParams = {
          1: (options.ati.hasOwnProperty('x1') ? options.ati.x1 : $ati.data('x1')) || '',
          2: this.toAtiString((options.ati.hasOwnProperty('x2') ? options.ati.x2 : $ati.data('x2')) || ''),
          3: (options.ati.hasOwnProperty('x3') ? options.ati.x3 : $ati.data('x3')) || '',
          4: (options.ati.hasOwnProperty('x4') ? options.ati.x4 : $ati.data('x4')) || '',
          5: (options.ati.hasOwnProperty('x5') ? options.ati.x5 : $ati.data('x5')) || '',
          6: (options.ati.hasOwnProperty('x6') ? options.ati.x6 : $ati.data('x6')) || '',
          7: (options.ati.hasOwnProperty('x7') ? options.ati.x7 : $ati.data('x7')) || '',
          8: (options.ati.hasOwnProperty('x8') ? options.ati.x8 : $ati.data('x8')) || '',
          9: (options.ati.hasOwnProperty('x9') ? options.ati.x9 : $ati.data('x9')) || '',
          10: encodeURIComponent((options.hasOwnProperty('url') && undefined !== options.url && null !== options.url && '' !== options.url) ? options.url : COMMON.Utils.getCanonical()),
          11: (options.ati.hasOwnProperty('x11') ? options.ati.x11 : $ati.data('x11')) || '',
          12: (options.ati.hasOwnProperty('x12') ? options.ati.x12 : $ati.data('x12')) || ''
        };

        for (var propName in siteParams) {
          if (null === siteParams[propName] || undefined === siteParams[propName] || '' === siteParams[propName]) {
            delete siteParams[propName];
          }
        }

        tag.customVars.set({
          site: siteParams
        });

        // Suchseite
        var $suchseiteContainer = $(document).find('.suchseite');
        if (0 !== $suchseiteContainer.length) {
          try {
            var keyword = getKeyword();
            var resultPageNumber = (0 === $suchseiteContainer.find('.teaser').length ? 0 : getSearchResultPageNumber());

            tag.internalSearch.set({
              keyword: keyword,
              resultPageNumber: resultPageNumber
            });
          } catch (e) {
            console.log(e);
          }
        }

        tag.dispatch();
      }
    },

    /**
     * @params object options {category, action, title}
     */
    click: function click(options) {
      if (typeof options === 'undefined') {
        options = {};
      }

      // Universal Analytics Web Tracking
      if ('undefined' !== typeof window.ga) {
        try {
          window.ga('send', 'event', options.category, options.action, options.title)
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e)
        }
      }

      // AT Internet
      if ('undefined' !== typeof window.ATInternet && 'undefined' !== typeof window.ATInternet.Tracker) {
        $ati = $('#ati');

        var tag = new window.ATInternet.Tracker.Tag(window.ati_options || {});

        tag.click.send({
          elem: null,
          name: this.toAtiString(options.title),
          chapter1: this.toAtiString(options.category),
          chapter2: this.toAtiString(options.action),
          level2: $ati.data('level2'),
          type: 'navigation'
        });
      }
    },

    /**
     * @params object options {network, action, title}
     */
    social: function social(options) {
      if (typeof options === 'undefined') {
        options = {};
      }

      // Universal Analytics Web Tracking
      if ('undefined' !== typeof window.ga) {
        try {
          window.ga('send', 'social', options.network, 'Social Sharing', COMMON.Pixel.toAtiString(($ati.data("x1") || location.href).split("_").pop()))
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e)
        }
      }

      // AT Internet
      if ('undefined' !== typeof window.ATInternet && 'undefined' !== typeof window.ATInternet.Tracker) {
        $ati = $('#ati');

        var tag = new window.ATInternet.Tracker.Tag(window.ati_options || {});
        var conf = {
          event: null,
          name: COMMON.Pixel.toAtiString(($ati.data("x1") || location.href).split("_").pop()),
          chapter1: 'Social Sharing',
          chapter2: COMMON.Pixel.toAtiString(options.network),
          level2: $ati.data('level2'),
          type: 'action'
        }
        tag.click.send(conf);
      }

    }

  };

  $(document)
    .on("pjax:success", function (event, data, status, xhr, options) {
      var fullDocument = /<html/i.test(data);
      var $head, $body;
      if (fullDocument) {
        $body = $($.parseHTML(data.match(/<body[^>]*>([\s\S.]*)<\/body>/i)[0]));
        var head = data.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
        $head = head !== null ? $($.parseHTML(head)) : $body;
      } else {
        $head = $body = $($.parseHTML(data));
      }
      options.url = findAll($head, 'link[rel="canonical"]').last().attr('href');
      Pixel.pageview(options)
    })
    .on('common:pixel:pageview', function (event, options) {
      Pixel.pageview(options)
    })
    .on('common:pixel:click', function (event, options) {
      Pixel.click(options)
    })
    .on('common:pixel:social', function (event, options) {
      Pixel.social(options)
    });

  function findAll(elems, selector) {
    return elems.filter(selector).add(elems.find(selector))
  }

  /**
   * Helper for Search
   * @returns {string}
   */
  function getKeyword() {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get('swx_q');
    } catch (e) {
      console.error(e, this);
      return 'Keyword unknown'
    }
  }

  /**
   * Helper for Search
   * @returns {number|number}
   */
  function getSearchResultPageNumber() {
    try {
      var url = new URL(window.location.href);
      var pageNumber = url.pathname.match(/_pagedaa2a08d-(\d+)/);
      return null === pageNumber ? 1 : (parseInt(pageNumber[1]) + 1);
    } catch (e) {
      return 1;
    }
  }

  return Pixel;

}(window.jQuery);
